import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { Vue } from "vue-property-decorator"
import ObjectHelper from "~/utils/ObjectHelper"
import { NewRequester } from "~/core/Requester"

interface IAgentState {
  agentDetail: IObjectState<any>
}

export const prefix = "agent/agent"

export const state = (): IAgentState => ({
  agentDetail: commonObjectState(),
})

export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.agentDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: IAgentState, data) => {
    Vue.set(state, "agentDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.agentDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.agentDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(state.agentDetail, e.response?.data || e)
      )
    }
  },
}
